import { render, staticRenderFns } from "./ThuxTableMixin.vue?vue&type=template&id=4429b8f7&"
import script from "./ThuxTableMixin.vue?vue&type=script&lang=js&"
export * from "./ThuxTableMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports